





import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class VeChainStatsLink extends Vue {
    @Prop(String) private address!: string
    get link() {
        return `https://vechainstats.com/account/${this.address}/`
    }
    private iconURL = require('../assets/vechainstats-logo.png')
}
